import { useIntl } from 'react-intl';
import { Badge } from 'src/registry/ui/Badge';
import { CURRENCY_FLAG_MAP, CURRENCY_MAP } from 'src/features/moneyAccounts/utils/constants';
import { commonMessages } from 'src/utils/messages';
import { CURRENCY } from 'src/types';

type CurrencyBadgeCellProps = {
    currency: CURRENCY;
};

export function CellCurrencyBadge({ currency }: CurrencyBadgeCellProps) {
    const { formatMessage } = useIntl();

    return (
        <Badge theme='primary'>
             <span className="inline-flex h-4 w-4 overflow-hidden rounded-full">
                <img src={CURRENCY_FLAG_MAP[currency]} alt={formatMessage(commonMessages.flag)} className="h-full w-full object-cover" />
             </span>
            {formatMessage(CURRENCY_MAP[currency])}
        </Badge>
    );
}
